import { ASSETS } from '@/modules/Celebrating20YearsPage/content';
import cx from 'classnames';
import Image from 'next/image';

import styles from './Lockup.module.scss';

interface LockupProps {
  size: 'hero' | 'small';
}

/**
 * The "20 Years in good hands" lockup. The hero version is the page's h1; the small version is
 * decorative artwork inside the 2026 milestone tile.
 */
const Lockup = ({ size }: LockupProps) => {
  if (size === 'hero') {
    return (
      <h1 className={cx(styles.lockup, styles.hero)}>
        <Image
          className={styles.mark}
          src={`${ASSETS}/lockup-20.svg`}
          alt="20"
          width={160}
          height={125}
          priority
        />
        <span className={styles.text}>
          Years in
          <br />
          good hands
        </span>
      </h1>
    );
  }

  return (
    <span
      className={cx(styles.lockup, styles.small)}
      role="img"
      aria-label="20 Years in good hands"
    >
      <Image
        className={styles.mark}
        src={`${ASSETS}/lockup-20-small.svg`}
        alt=""
        width={51}
        height={39}
      />
      <span className={styles.text} aria-hidden="true">
        Years in
        <br />
        good hands
      </span>
    </span>
  );
};

export default Lockup;
